import React, { FC } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 10,
  },
  text: {
    fontSize: 12,
    fontWeight: 300,
    letterSpacing: 0,
    lineHeight: "16px",
    "& a": {
      fontWeight: "bold",
      color: theme.palette.primary.contrastText,
      textDecoration: "none",
    },
  },
}));

export const Disclaimer: FC = () => {
  const classes = useStyles();
  return (
    <>
      <Grid container className={classes.root}>
        <Typography className={classes.text}>
          ARAG SE Rappresentanza Generale e Direzione per l&apos;Italia - Viale del Commercio, 59 , 37135 Verona P.I.
          04167600230 - C.F. e n. R.I. Verona 93238290238 - REA n. VR - 394658. Iscritta in data 20/08/2012
          all&apos;Albo Imprese di Assicurazione IVASS, Elenco I, n. I.00108 (Imprese comunitarie autorizzate ad operare
          in regime di stabilimento). Rappresentante Generale e Direttore Generale per l&apos;Italia: Andrea Andreta.
          Tel.: 045 8290411 - e-mail:{" "}
          <a href="mailto:arag@arag.it" target="_blank" rel="noopener noreferrer">
            arag@arag.it
          </a>{" "}
          - pec:{" "}
          <a href="mailto:arag@pec.arag.it" target="_blank" rel="noopener noreferrer">
            arag@pec.arag.it
          </a>{" "}
          - web:{" "}
          <a href="http://www.arag.it" target="_blank" rel="noopener noreferrer">
            www.arag.it
          </a>
          .
        </Typography>
        <br />
        <Typography className={classes.text}>
          ARAG SE - Societas Europaea - sede legale D - 40472 Düsseldorf (Germania), ARAG Platz 1 - Capitale sociale
          Euro 100.000.000. Iscritta nel Registro del Tribunale di Düsseldorf al n. HRB 66846 - Soggetta al controllo
          della Autorità di vigilanza tedesca Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin:{" "}
          <a href="http://www.bafin.de" target="_blank" rel="noopener noreferrer">
            www.bafin.de
          </a>
          ). Presidente del Consiglio di Sorveglianza: Dr. Paul-Otto Faßbender. Consiglio di Gestione: Dr. Renko Dirksen
          (Chairman of the Management Board), Dr. Matthias Maslaton, Wolfgang Mathmann, Dr. Shiva Meyer, Hanno Petersen,
          Dr. Joerg Schwarze.
        </Typography>
      </Grid>
    </>
  );
};
